/**
 * Pfade, auf denen das Gate nicht erscheint.
 *
 * Warum eine ausdrueckliche Liste und nicht die Layout-Struktur:
 * AdaptiveLayout rendert fuer eingeloggte Nutzer AppLayout, /legal/privacy
 * und /legal/terms liegen also im selben Layout wie die App. Haengte das
 * Gate am Layout, verdeckte es genau die Texte, zu denen es Zustimmung
 * verlangt. Und umgekehrt liegen /chat und /onboarding ganz ausserhalb von
 * AppLayout und blieben ungeschuetzt.
 *
 * Bewusst NICHT ausgenommen ist /invite/:token: eine Partner-Verbindung
 * haengt an einer Schwangerschaft, das ist Verarbeitung von
 * Gesundheitsdaten. Der Eingeladene beantwortet erst das Gate, dann steht
 * die Seite offen.
 */
const EXEMPT_PATHS = [
  // Auth - ohne diese Ausnahme sperrte sich das Gate selbst aus
  '/login',
  '/register',
  '/reset-password',
  '/auth/callback',
  '/auth/confirm',
  // Die Texte, um die es geht
  '/legal',
  // Hilfe und Kontakt - wer eine Rueckfrage zur Einwilligung hat, muss sie
  // stellen koennen, ohne vorher zuzustimmen
  '/help',
  // Betroffenenrechte (Art. 15 ff.) duerfen nie hinter einer Einwilligung liegen
  '/gdpr',
  '/profile/gdpr',
];

export function isConsentExemptPath(pathname: string): boolean {
  return EXEMPT_PATHS.some(
    (path) => pathname === path || pathname.startsWith(`${path}/`)
  );
}
